import {
  gallery_default
} from "./chunk-7NECJJPD.js";

// src/modules/gallery/gallery.tsx
import { jsx } from "react/jsx-runtime";
var mGallery = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  if (!content?.images) return null;
  return /* @__PURE__ */ jsx(
    "section",
    {
      className,
      "data-module-sequence": sequence,
      "data-module-type": "mGallery",
      id: _id,
      children: /* @__PURE__ */ jsx(gallery_default, { id: `${_id}_gallery`, ...content })
    }
  );
};
var gallery_default2 = mGallery;

export {
  gallery_default2 as gallery_default
};
